import React, { Component } from 'react'
import { withTranslation } from 'react-i18next';
import styled from 'styled-components'
import { connect } from "react-redux";
import HelpfulInformation from '../HelpfulInformation'
import Faqs from '../Faqs'
import siteContentService from '../../../services/SiteContent.service'
import employeeService from '../../../services/Employee.service'

const Container = styled.div`
  background-color: white;
`

export class MoreAboutStocks extends Component {
  state = {}
  render() {
    return (
      <Container id="more">
        <HelpfulInformation articles={this.props.articles} background='white'/>
        <Faqs faqs={this.props.faqs} />
      </Container>
    )
  }
}

const mapState = state => ({
  articles: siteContentService.getHomepageArticles(state.static_content, employeeService.isZooxEmployee(state.employee)),
  faqs: state.static_content.helpful_information.faq
});

export default connect(mapState)(withTranslation("translations")(MoreAboutStocks));
